import { call, put } from 'redux-saga/effects';
import axios from 'axios';
import {
    didApiCallFailDueToUnauthorizedUser,
    didApiCallFailDueToVersionMismatch,
    getErrorMessage,
} from '../../constants/CommonUtil';
import {
    FETCH_BILLED_PACKAGES_STATUS_SUCCESS, FETCH_BILLED_PACKAGES__STATUS_FAILURE,

} from '../../redux/modules/billedMedicalPackageStatus/billedMedicalPackageStatus-actions';
import { MISMATCH_IN_VERSION, SESSION_TIMEOUT } from '../../redux/modules/login/login-actions';
import { ERROR_MESSAGE } from '../../redux/modules/message/message-actions';
import { HIDE_SPINNER, SHOW_SPINNER } from '../../redux/modules/spinner/spinner';

function* fetchBilledPackagesStatusWorker(action) {
    try {
        const {
            api,
            size,
            searchConstruct,
            seekDirection,
            seekParams,
        } = action;
        const encodedSeekParams = seekParams ? encodeURIComponent(JSON.stringify(seekParams)) : undefined;
        let apiWithParams = `${api}?size=${size}&direction=${seekDirection}`;
        if (encodedSeekParams) {
            apiWithParams += `&seekParams=${encodedSeekParams}`;
        }
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        const config = {
            headers: { 'Content-Type': 'application/json' },
        };
        const response = yield call(axios.post, apiWithParams, searchConstruct, config);
        yield put({
            type: FETCH_BILLED_PACKAGES_STATUS_SUCCESS,
            data: response.data || {},
            seekParams,
        });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    } catch (e) {
        if (didApiCallFailDueToUnauthorizedUser(e)) {
            yield put({ type: SESSION_TIMEOUT, actionToDispatchAfterLogin: action });
        } else if (didApiCallFailDueToVersionMismatch(e)) {
            yield put({ type: MISMATCH_IN_VERSION });
        } else {
            const msg = 'Fetching billed packages status failed';
            yield put({ type: ERROR_MESSAGE, message: `${msg}: ${getErrorMessage(e)}` });
        }
        yield put({ FETCH_BILLED_PACKAGES__STATUS_FAILURE, data: {} });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    }
}

export default fetchBilledPackagesStatusWorker;
